import { ReactElement, cloneElement } from 'react'
import { IconLock, Tooltip, Button } from '@sequencehq/core-components'
import { PermissionString } from './types'
import { Protected } from './Protected'

interface ProtectedButtonProps {
  permission: PermissionString | PermissionString[]
  needsEveryPermission?: boolean
  children: ReactElement<typeof Button>
  tooltipMessage?: string
}

export const ProtectedButton = ({
  permission,
  needsEveryPermission = false,
  children,
  tooltipMessage = "This action isn't available for your current role"
}: ProtectedButtonProps) => {
  return (
    <Protected
      permission={permission}
      needsEveryPermission={needsEveryPermission}
    >
      {isAllowed => {
        if (isAllowed) {
          return children
        }

        return (
          <Tooltip label={tooltipMessage} shouldWrapChildren={false}>
            {cloneElement(children, {
              ...children.props,
              // Strip `as`/`to` so a Button rendered as a router Link reverts
              // to a real <button disabled> when permission is denied — anchor
              // elements ignore the disabled prop and remain navigable.
              as: undefined,
              to: undefined,
              disabled: true,
              leadingIcon: <IconLock />,
              onClick: undefined
            } as unknown as React.ComponentProps<typeof Button>)}
          </Tooltip>
        )
      }}
    </Protected>
  )
}
